import { render, staticRenderFns } from "./PertanyaanContent.vue?vue&type=template&id=609d17bb&scoped=true"
import script from "./PertanyaanContent.vue?vue&type=script&lang=js"
export * from "./PertanyaanContent.vue?vue&type=script&lang=js"
import style0 from "./PertanyaanContent.vue?vue&type=style&index=0&id=609d17bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609d17bb",
  null
  
)

export default component.exports